import { useMemo } from 'react';
import { Query } from '@/utils/react-query/Queries';
import { notificationMatchesScope } from '@/utils/hooks/useMarkNotificationsRead';

const CONNECT_TYPES = ["NEW_POST", "MESSAGE_RECEIVED", "NEW_COMMENT", "ORGANIZATION_ANNOUNCEMENT"];
const BOARDS_TYPES = ["NEW_POST", "NEW_COMMENT", "ORGANIZATION_ANNOUNCEMENT"];
const CONVERSATIONS_TYPES = ["MESSAGE_RECEIVED"];

/**
 * Shared notification badge selectors off the loggedInUser cache.
 * Returns memoized counts so all badges (tab bar, drawer, lists, header) agree.
 */
const useNotificationBadges = () => {
    const { data: loggedInUser } = Query.people.loggedInUser();
    const notifications = loggedInUser?.Notifications;

    return useMemo(() => {
        const unread = (notifications || []).filter(n => !n.isRead);
        return {
            totalUnread: unread.length,
            connectUnread: unread.filter(n => CONNECT_TYPES.includes(n.notificationType)).length,
            boardsUnread: unread.filter(n => BOARDS_TYPES.includes(n.notificationType)).length,
            conversationsUnread: unread.filter(n => CONVERSATIONS_TYPES.includes(n.notificationType)).length,
            conversationUnread: (id) => unread.filter(n => notificationMatchesScope(n, { conversationID: id })).length,
            boardUnread: (id) => unread.filter(n => notificationMatchesScope(n, { boardID: id })).length,
        };
    }, [notifications]);
};

export default useNotificationBadges;
